import { Table } from "../../components/Table"
import { useAdminTenants } from "../../hooks/useApi"

export default function AdminTenantsPage() {
  const { data, isLoading, error } = useAdminTenants()
  const rows = data?.items ?? []

  if (isLoading) {
    return <p className="small">Loading tenants…</p>
  }

  if (error) {
    return <p className="small">Unable to load tenants.</p>
  }

  return (
    <Table
      data={rows}
      getRowId={(row) => String(row.id)}
      columns={[
        { key: "name", title: "Tenant" },
        {
          key: "stripe_account_id",
          title: "Stripe",
          render: (row) => row.stripe_account_id ?? "—",
        },
        {
          key: "application_fee_bps",
          title: "Fee (bps)",
          width: "120px",
        },
        {
          key: "updated_at",
          title: "Updated",
          render: (row) => new Date(row.updated_at).toLocaleString(),
        },
      ]}
    />
  )
}
